@if (vesselId() && endpoint()) {
    <core-generic-table
        [endpoint]="endpoint()"
        [columns]="columns()"
        [modalFields]="modalFields()"
        [actions]="actions()"
        [modelFactory]="modelFactory"
        [title]="'vessels.fuel.table_title' | translate"
        [listTitle]="'vessels.fuel.list_title' | translate"
        [showFilter]="false"
        [showCreateButton]="true"
        [showSelection]="false"
        [enablePagination]="true"
        (modalData)="onModalData($event)"
        [globalActions]="globalCustomActions()"
    >
    </core-generic-table>
} @else {
    <div class="c-empty-state">
        <p>{{ 'service_subgroups.loading' | translate }}</p>
    </div>
}